import React, { memo, useEffect, useState } from "react";

import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { useThemes } from "../Theme/theme";
import { useSelector } from "react-redux";

function GSTR3BTable3({ data }) {
  const { theme } = useThemes()


  const [state, setState] = useState([])

  const companyDetails = useSelector((state) => state?.companyReducer?.companyDetails)

  useEffect(() => {
    if (data[0]?.GSTR2Data) {
      GSTR3BTable3FN()
    }

  }, [data])

  async function GSTR3BTable3FN() {
    const eligibleITC1 = {
      type: "a",
      integratedTax: 0,
      centralTax: 0,
      stateTax: 0,
      cess: 0,
    };
    const eligibleITC2 = {
      type: "a",
      integratedTax: 0,
      centralTax: 0,
      stateTax: 0,
      cess: 0,
    };
    const eligibleITC3 = {
      type: "a",
      integratedTax: 0,
      centralTax: 0,
      stateTax: 0,
      cess: 0,
    };
    const eligibleITC4 = {
      type: "a",
      integratedTax: 0,
      centralTax: 0,
      stateTax: 0,
      cess: 0,
    };
    const eligibleITC5 = {
      type: "a",
      integratedTax: 0,
      centralTax: 0,
      stateTax: 0,
      cess: 0,
    };
    const eligibleITC6 = {
      type: "b",
      integratedTax: 0,
      centralTax: 0,
      stateTax: 0,
      cess: 0,
    };

    const GSTR3BPurchase = data[0]?.GSTR2Data;

    GSTR3BPurchase.forEach((purchase) => {
      purchase?.relatedpurchaselineitems.forEach((item) => {
        if (
          companyDetails?.relatedaddressentity[0]?.countrycode ===
          "IndiaState" &&
          purchase?.relatedpartymaster[0].partytypecd === "SUPPLIER" &&
          item.relateditemmaster[0].itemtype === "GOODS"
        ) {
          const totalValue = item.itemrate * item.itemquantity;
          const gstItem = item?.relatedpurchaselinegst[0];
          eligibleITC1.integratedTax = (totalValue * gstItem?.gstrate) / 100;
          eligibleITC1.cess += gstItem?.cessamount;
        }
        if (
          companyDetails?.relatedaddressentity[0]?.countrycode ===
          "IndiaState" &&
          purchase?.relatedpartymaster[0].partytypecd === "SUPPLIER" &&
          item.relateditemmaster[0].itemtype === "SERVICE"
        ) {
          const totalValue = item.itemrate * item.itemquantity;
          const gstItem = item.relatedpurchaselinegst[0];
          eligibleITC2.integratedTax = (totalValue * gstItem?.gstrate) / 100;
          eligibleITC2.cess += gstItem?.cessamount;
        }
        if (
          purchase?.relatedpartymaster[0].partytypecd === "SUPPLIER" &&
          purchase?.relatedpurchasetdsdetails[0].reversechargeflag === 1
        ) {
          const totalValue = item.itemrate * item.itemquantity;
          const gstItem = item.relatedpurchaselinegst[0];
          const taxAmount = (totalValue * gstItem?.gstrate) / 100;
          eligibleITC3.cess += gstItem?.cessamount;
          if (
            companyDetails?.relatedaddressentity[0]?.statecode ===
            purchase?.placeofsupply
          ) {
            eligibleITC3.centralTax += taxAmount / 2;
            eligibleITC3.stateTax += taxAmount / 2;
          } else {
            eligibleITC3.integratedTax += taxAmount;
          }
        }
        if (
          // purchase?.RelatedPartyMaster[0].Country === "IndiaState" &&
          purchase?.relatedpartymaster[0]?.partytypecd === "SUPPLIER" &&
          purchase?.relatedpurchasetdsdetails[0]?.reversechargeflag === 0
        ) {
          const totalValue = item?.itemrate * item?.itemquantity;
          const gstItem = item?.relatedpurchaselinegst[0];
          const taxAmount = (totalValue * gstItem?.gstrate) / 100;
          eligibleITC5.cess += gstItem?.cessamount;
          if (
            companyDetails?.relatedaddressentity[0]?.statecode ===
            purchase?.placeofsupply
          ) {
            eligibleITC5.centralTax += taxAmount / 2;
            eligibleITC5.stateTax += taxAmount / 2;
          } else {
            eligibleITC5.integratedTax += taxAmount;
          }
        }
        if (
          // purchase?.RelatedPartyMaster[0].Country === "IndiaState" &&
          purchase?.relatedpartymaster[0]?.partytypecd === "SUPPLIER" &&
          purchase?.relatedpurchasetdsdetails[0]?.ineligibletcflag === 1
        ) {
          const totalValue = item?.itemrate * item?.itemquantity;
          const gstItem = item?.relatedpurchaselinegst[0];
          const taxAmount = (totalValue * gstItem?.gstrate) / 100;
          eligibleITC6.cess += gstItem?.cessamount;
          if (
            companyDetails?.relatedaddressentity[0]?.statecode ===
            purchase?.placeofsupply
          ) {
            eligibleITC6.centralTax += taxAmount / 2;
            eligibleITC6.stateTax += taxAmount / 2;
          } else {
            eligibleITC6.integratedTax += taxAmount;
          }
        }
      });
    });
    setState([
      eligibleITC1,
      eligibleITC2,
      eligibleITC3,
      eligibleITC4,
      eligibleITC5,
      eligibleITC6,
    ]);
  }





  const A = [
    "(1)   Import of goods ",
    "(2)   Import of services",
    "(3)   Inward supplies liable to reverse charge (other than 1 &2 above)",
    "(4)   Inward supplies from ISD",
    "(5)   All other ITC",
  ];
  const B = [
    "(1) As per rules 38,42 & 43 of CGST Rules and section 17(5)",
    "(2)   Others",
  ];
  const headCells = [
    {
      id: "1",
      label: "details",
      minWidht: 170,
    },
    {
      id: "3",
      label: "integrated tax",
      minWidht: 120,
    },
    {
      id: "4",
      label: "central tax",
      minWidht: 120,
    },
    {
      id: "3",
      label: "state/ut tax",
      minWidht: 120,
    },
    {
      id: "3",
      label: "cess",
      minWidht: 120,
    },
  ];
  if (state.lenght > 0) {
  }
  const sums = state.reduce((acc, item) => {
    const type = item.type;
    if (!acc[type]) {
      acc[type] = { integratedTax: 0, centralTax: 0, stateTax: 0, cess: 0 };
    }
    acc[type].integratedTax += item.integratedTax;
    acc[type].centralTax += item.centralTax;
    acc[type].stateTax += item.stateTax;
    acc[type].cess += item.cess;
    return acc;
  }, {});

  return (
    <>
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          marginTop: 3,
        }}
      >
        <Typography sx={{ paddingX: 1 }}>
          3. Details of eligible input Tax credit
        </Typography>
        <TableContainer
          sx={{
            m: 1,
            "::-webkit-scrollbar": {
              width: 14,
            },
            "::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "::-webkit-scrollbar-thumb": {
              background: "#888",
            },
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              width: "100%",
              borderRadius: 2,
              backgroundColor: "#f9f9fe",
            }}
          >
            <TableHead
              sx={{
                height: 12,
              }}
            >
              <TableRow>
                {headCells?.map((column) => (
                  <TableCell
                    align="center"
                    sx={{
                      color: "#FFF",
                      backgroundColor: theme.palette.secondary.main,
                      fontFamily: "overpass",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                    key={column.id}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  (A) ITC Available (Whether in full or part)
                </TableCell>
                <TableCell>
                  {sums["a"]?.integratedTax ? sums["a"].integratedTax : 0}
                </TableCell>
                <TableCell>
                  {sums["a"]?.centralTax ? sums["a"].centralTax : 0}
                </TableCell>
                <TableCell>
                  {sums["a"]?.stateTax ? sums["a"].stateTax : 0}
                </TableCell>
                <TableCell>{sums["a"]?.cess ? sums["a"].cess : 0}</TableCell>
              </TableRow>
              {A.map((points, idx) => {
                return (
                  <>
                    <TableRow key={idx}>
                      <TableCell>{points}</TableCell>
                      <TableCell>
                        {state[idx]?.integratedTax
                          ? state[idx]?.integratedTax
                          : 0}
                      </TableCell>
                      <TableCell>
                        {state[idx]?.centralTax ? state[idx]?.centralTax : 0}
                      </TableCell>
                      <TableCell>
                        {state[idx]?.stateTax ? state[idx]?.stateTax : 0}
                      </TableCell>
                      <TableCell>
                        {state[idx]?.cess ? state[idx]?.cess : 0}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}

              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  (B) ITC Reversed
                </TableCell>
                <TableCell>
                  {sums["b"]?.integratedTax ? sums["b"].integratedTax : 0}
                </TableCell>
                <TableCell>
                  {sums["b"]?.centralTax ? sums["b"].centralTax : 0}
                </TableCell>
                <TableCell>
                  {sums["b"]?.stateTax ? sums["b"].stateTax : 0}
                </TableCell>
                <TableCell>{sums["b"]?.cess ? sums["b"].cess : 0}</TableCell>
              </TableRow>
              {B.map((points, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell>{points}</TableCell>
                    <TableCell>
                      {state[idx + 5]?.integratedTax
                        ? state[idx + 5].integratedTax
                        : 0}
                    </TableCell>
                    <TableCell>
                      {state[idx + 5]?.centralTax ? state[idx + 5].centralTax : 0}
                    </TableCell>
                    <TableCell>
                      {state[idx + 5]?.stateTax ? state[idx + 5].stateTax : 0}
                    </TableCell>
                    <TableCell>
                      {state[idx + 5]?.cess ? state[idx + 5].cess : 0}
                    </TableCell>
                  </TableRow>
                );
              })}

              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  (C) Net ITC Available (A)-(B)
                </TableCell>
                <TableCell>
                  {sums["a"]?.integratedTax - sums["b"]?.integratedTax || 0}
                </TableCell>
                <TableCell>
                  {sums["a"]?.centralTax - sums["b"]?.centralTax || 0}
                </TableCell>
                <TableCell>
                  {sums["a"]?.stateTax - sums["b"]?.stateTax || 0}
                </TableCell>
                <TableCell> {sums["a"]?.cess - sums["b"]?.cess || 0}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}

export default memo(GSTR3BTable3);
